import styled from 'styled-components';
import reset from '../reset';
import em from '../em';

export default styled.div`
  ${reset()}
  margin-bottom: ${em(1)}
`;
